import { createSSRApp } from 'vue'
import App from './App.vue'
import { setupStore } from './store'
// import { routeInterceptor, requestInterceptor, prototypeInterceptor } from '@/services/interceptors'
import permissionDirective from '@/services/permission/index'
import { initDomainConfig } from '@/config/domain'
import { recoverCollaborationRoute } from '@/services/collaboration-login/session'
import { installAuthenticationGuard, prepareAuthenticationEntry } from '@/services/collaboration-login/bootstrap'
import { captureLoginTenantEntry } from '@/services/utils/tenantScope'
import { installCollaborationBindingGuide } from '@/services/collaboration-binding'

import 'virtual:uno.css'
// import * as Sentry from '@sentry/vue'

if (typeof window !== 'undefined') {
    captureLoginTenantEntry(location.href)
    recoverCollaborationRoute()
    void initDomainConfig()
}

export function createApp() {
    // #ifdef H5
    prepareAuthenticationEntry()
    // #endif
    const app = createSSRApp(App)

    // 先将 Sentry 注释掉，因为他是收费的

    // Sentry.init({
    //     app,
    //     dsn: 'https://5a0f0303e0e9fffe1762603145ef203c@o4509398502801408.ingest.us.sentry.io/4509398506995712',
    //     // 将此选项设置为 true 将默认发送 PII（个人可识别信息）数据到 Sentry。
    //     // 例如，会自动收集事件的 IP 地址。
    //     sendDefaultPii: true,
    //     // 集成功能：Replay（用户会话回放）
    //     integrations: [Sentry.replayIntegration()],
    //     // 会话回放（Session Replay）功能
    //     replaysSessionSampleRate: 1.0,
    //     // 这表示以 10% 的概率采样用户会话用于回放。
    //     // 在开发环境中你可能希望将其设置为 100%，而在生产环境中使用较低的采样率。
    //     replaysOnErrorSampleRate: 1.0
    //     // 如果你没有采样所有会话，可以将发生错误的会话采样率设置为 100%，
    //     // 这样出现错误的会话就一定会被记录下来。
    // })

    // 安装 pinia
    setupStore(app)
    installAuthenticationGuard()
    installCollaborationBindingGuide(app)

    // app.use(routeInterceptor)
    // app.use(requestInterceptor)
    // app.use(prototypeInterceptor)

    // 注册 v-permission
    app.directive('permission', permissionDirective)
    return {
        app
    }
}
